
  import {mapGetters} from 'vuex'

  import TrackComponent from "../common/TrackComponent";
  import FiltersComponent from "../catalogPage/FiltersComponent";
  import Observer from "../common/ObserverComponent";

  export default {
    name: "CatalogPageView",
    components: {Observer, FiltersComponent, TrackComponent},
    props: {},
    data() {
      return {
        isShowFilters: false
      }
    },
    computed: {
      ...mapGetters('tracks', ['trackList', 'nextPage']),
      queryParams() {
        return {...this.$route.query}
      },
    },
    methods: {
      async intersected() {
        if (this.nextPage) {
          await this.$store.dispatch('tracks/loadingTrackList', {...this.queryParams, page: this.nextPage})
        }
      },

      toolgeFilters() {
        this.isShowFilters = !this.isShowFilters
      }
    }
  }
